export default "/packs/images/carabiner-1~6ddd974c3051de8fea3237d9ebef182b.png";